import React from "react"

type Props = {
  page: number
  pages: number
  onPage: (page: number) => void
}

// Windowed page list: 1 … (p-1) p (p+1) … last, collapsing runs with a gap.
export const pageWindow = (page: number, pages: number): (number | "gap")[] => {
  const out: (number | "gap")[] = []
  const want = new Set<number>([1, pages, page - 1, page, page + 1])
  let last = 0
  for (let p = 1; p <= pages; p++) {
    if (!want.has(p)) continue
    if (p - last > 1) out.push("gap")
    out.push(p)
    last = p
  }
  return out
}

// Numbered pager mirroring the prospects/clients pagy nav: prev arrow, windowed
// page numbers with the current one highlighted, next arrow.
export const TablePager: React.FC<Props> = ({ page, pages, onPage }) => {
  const total = Math.max(1, pages)

  return (
    <nav className="fsp-admin__pager pagy" aria-label="Pagination">
      <button
        type="button"
        className="fsp-admin__pager-arrow fsp-admin__pager-prev"
        disabled={page <= 1}
        onClick={() => onPage(page - 1)}
      >
        Previous
      </button>
      {pageWindow(page, total).map((p, i) =>
        p === "gap" ? (
          <span key={`gap-${i}`} className="fsp-admin__pager-gap">…</span>
        ) : (
          <button
            key={p}
            type="button"
            className={`fsp-admin__pager-page ${p === page ? "fsp-admin__pager-page--current" : ""}`}
            onClick={() => onPage(p)}
            aria-current={p === page ? "page" : undefined}
          >
            {p}
          </button>
        )
      )}
      <button
        type="button"
        className="fsp-admin__pager-arrow fsp-admin__pager-next"
        disabled={page >= total}
        onClick={() => onPage(page + 1)}
      >
        Next
      </button>
    </nav>
  )
}
